import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  FaRocket,
  FaLink,
  FaChartLine,
  FaCode,
  FaServer,
  FaMobile,
  FaBug,
  FaCloud,
  FaCheckCircle,
  FaUsers,
  FaBuilding,
  FaClock,
  FaGlobe,
  FaHandshake,
  FaShieldAlt,
  FaStar,
  FaArrowRight,
  FaPlayCircle,
  FaQuoteLeft,
  FaAward,
  FaApple,
  FaAndroid,
  FaCog
} from 'react-icons/fa';
import {
  SiReact,
  SiFlutter,
  SiIonic,
  SiSwift,
  SiKotlin,
  SiXamarin,
  SiVuedotjs,
  SiAngular,
  SiNextdotjs,
  SiTypescript,
  SiJavascript,
  SiHtml5,
  SiCss3,
  SiSass,
  SiTailwindcss,
  SiMysql,
  SiPostgresql,
  SiMongodb,
  SiRedis,
  SiOracle,
  SiSqlite,
  SiFirebase,
  SiAmazondynamodb,
  SiNodedotjs,
  SiPython,
  SiDotnet,
  SiPhp,
  SiRuby,
  SiGo,
  SiLaravel,
  SiWordpress,
  SiDrupal,
  SiJoomla,
  SiMagento,
  SiShopify,
  SiContentful,
  SiAmazonaws,
  SiMicrosoftazure,
  SiDocker,
  SiKubernetes,
  SiJenkins,
  SiGitlab,
  SiGithub,
  SiTerraform
} from 'react-icons/si';

const Home = () => {
  const [selectedTechCategory, setSelectedTechCategory] = useState('MOBILE');

  const technologyCategories = ['MOBILE', 'FRONT END', 'DATABASE', 'BACK END', 'CMS', 'INFRA & DEVOPS'];

  const technologies = {
    'MOBILE': [
      { name: 'iOS', icon: <FaApple /> },
      { name: 'Android', icon: <FaAndroid /> },
      { name: 'React Native', icon: <SiReact /> },
      { name: 'Flutter', icon: <SiFlutter /> },
      { name: 'Ionic', icon: <SiIonic /> },
      { name: 'Swift', icon: <SiSwift /> },
      { name: 'Kotlin', icon: <SiKotlin /> },
      { name: 'ObjectiveC', icon: <FaCode /> },
      { name: 'Phone Gap', icon: <FaMobile /> },
      { name: 'Titanium', icon: <FaCog /> },
      { name: 'Xamarin', icon: <SiXamarin /> }
    ],
    'FRONT END': [
      { name: 'React', icon: <SiReact /> },
      { name: 'Vue.js', icon: <SiVuedotjs /> },
      { name: 'Angular', icon: <SiAngular /> },
      { name: 'Next.js', icon: <SiNextdotjs /> },
      { name: 'TypeScript', icon: <SiTypescript /> },
      { name: 'JavaScript', icon: <SiJavascript /> },
      { name: 'HTML5', icon: <SiHtml5 /> },
      { name: 'CSS3', icon: <SiCss3 /> },
      { name: 'Sass', icon: <SiSass /> },
      { name: 'Tailwind', icon: <SiTailwindcss /> }
    ],
    'DATABASE': [
      { name: 'MySQL', icon: <SiMysql /> },
      { name: 'PostgreSQL', icon: <SiPostgresql /> },
      { name: 'MongoDB', icon: <SiMongodb /> },
      { name: 'Redis', icon: <SiRedis /> },
      { name: 'Oracle', icon: <SiOracle /> },
      { name: 'SQLite', icon: <SiSqlite /> },
      { name: 'Firebase', icon: <SiFirebase /> },
      { name: 'DynamoDB', icon: <SiAmazondynamodb /> }
    ],
    'BACK END': [
      { name: 'Node.js', icon: <SiNodedotjs /> },
      { name: 'Python', icon: <SiPython /> },
      { name: 'Java', icon: <FaCode /> },
      { name: '.NET', icon: <SiDotnet /> },
      { name: 'PHP', icon: <SiPhp /> },
      { name: 'Ruby', icon: <SiRuby /> },
      { name: 'Go', icon: <SiGo /> },
      { name: 'Laravel', icon: <SiLaravel /> }
    ],
    'CMS': [
      { name: 'WordPress', icon: <SiWordpress /> },
      { name: 'Drupal', icon: <SiDrupal /> },
      { name: 'Joomla', icon: <SiJoomla /> },
      { name: 'Magento', icon: <SiMagento /> },
      { name: 'Shopify', icon: <SiShopify /> },
      { name: 'Contentful', icon: <SiContentful /> }
    ],
    'INFRA & DEVOPS': [
      { name: 'AWS', icon: <SiAmazonaws /> },
      { name: 'Azure', icon: <SiMicrosoftazure /> },
      { name: 'Docker', icon: <SiDocker /> },
      { name: 'Kubernetes', icon: <SiKubernetes /> },
      { name: 'Jenkins', icon: <SiJenkins /> },
      { name: 'GitLab', icon: <SiGitlab /> },
      { name: 'GitHub', icon: <SiGithub /> },
      { name: 'Terraform', icon: <SiTerraform /> }
    ]
  };

  const testimonials = [
    {
      name: "Sarah Johnson",
      role: "CTO, TechFlow Solutions",
      content: "The Code Icon helped us scale our engineering team from 5 to 15 developers in just 3 weeks. Their developers integrated seamlessly and delivered production-ready code from day one.",
      rating: 5
    },
    {
      name: "Michael Chen",
      role: "VP Engineering, DataSync Inc",
      content: "We needed specialized DevOps expertise for our cloud migration. The Code Icon provided exactly what we needed with zero learning curve. Highly recommended.",
      rating: 5
    },
    {
      name: "Emily Rodriguez",
      role: "Founder, StartupBoost",
      content: "As a startup, we couldn't afford the hiring delays. The Code Icon's staff augmentation model saved us 3 months and $50K in hiring costs.",
      rating: 5
    }
  ];

  const stats = [
    { icon: <FaUsers />, number: "150+", label: "Expert Engineers", description: "Pre-vetted senior developers" },
    { icon: <FaBuilding />, number: "150+", label: "Happy Clients", description: "Across startups & enterprises" },
    { icon: <FaClock />, number: "24-72hrs", label: "Profile Delivery", description: "Fast response time" },
    { icon: <FaGlobe />, number: "Global", label: "Timezone Support", description: "US & EU overlap" },
    { icon: <FaAward />, number: "4.9/5", label: "Client Rating", description: "Industry leading satisfaction" },
    { icon: <FaHandshake />, number: "99%", label: "Retention Rate", description: "Long-term partnerships" }
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="section" style={{ paddingTop: '120px', backgroundColor: 'var(--bg-grey-light)', position: 'relative', overflow: 'hidden' }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.05) 0%, rgba(16, 185, 129, 0.02) 100%)',
          zIndex: 1
        }}></div>
        <div className="container text-center" style={{ position: 'relative', zIndex: 2 }}>
          <div style={{ marginBottom: '24px' }}>
            <span style={{
              backgroundColor: 'var(--primary-green)',
              color: 'white',
              padding: '8px 16px',
              borderRadius: '20px',
              fontSize: '14px',
              fontWeight: '600',
              display: 'inline-block',
              marginBottom: '16px'
            }}>
              🚀 Staff Augmentation Experts
            </span>
          </div>
          <h1 className="h1" style={{ marginBottom: '24px', lineHeight: '1.1' }}>
            Scale Your Engineering Team<br />
            <span style={{ color: 'var(--primary-green)' }}>Without Hiring Delays</span>
          </h1>
          <p className="text-lg mb-6" style={{ maxWidth: '700px', margin: '0 auto 32px', fontSize: '20px', color: 'var(--text-medium)' }}>
            Access dedicated developers who integrate seamlessly with your in-house team.
            Fast onboarding, full transparency, flexible scaling, and enterprise-grade security.
          </p>
          <div style={{ marginBottom: '48px' }}>
            <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/calculator" className="btn btn-primary btn-lg" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <FaRocket /> Get Team Cost Estimate
              </Link>
              <Link to="/contact" className="btn btn-secondary btn-lg" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <FaPlayCircle /> Schedule a Call
              </Link>
            </div>
            <p style={{ fontSize: '14px', color: 'var(--text-medium)', marginTop: '16px' }}>
              ✓ No setup fees • ✓ Cancel anytime • ✓ Enterprise security
            </p>
          </div>
        </div>
      </section>

      {/* Trust Indicators */}
      <section className="section" style={{ backgroundColor: 'white', borderTop: '1px solid var(--border-grey)', borderBottom: '1px solid var(--border-grey)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            <h2 className="h2" style={{ marginBottom: '16px' }}>Trusted by Industry Leaders</h2>
            <p style={{ color: 'var(--text-medium)', fontSize: '18px' }}>
              Join 150+ companies that have successfully scaled their engineering teams
            </p>
          </div>
          <div className="grid grid-3" style={{ gap: '32px' }}>
            {stats.map((stat, index) => (
              <div key={index} className="card text-center" style={{ padding: '32px', border: '1px solid var(--border-grey)' }}>
                <div style={{ color: 'var(--primary-green)', marginBottom: '16px', fontSize: '32px' }}>
                  {stat.icon}
                </div>
                <div style={{ fontSize: '36px', fontWeight: '700', color: 'var(--primary-green)', marginBottom: '8px' }}>
                  {stat.number}
                </div>
                <div style={{ fontSize: '18px', fontWeight: '600', marginBottom: '8px' }}>
                  {stat.label}
                </div>
                <div style={{ color: 'var(--text-medium)', fontSize: '14px' }}>
                  {stat.description}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What is Staff Augmentation Section */}
      <section className="section section-grey">
        <div className="container">
          <div className="text-center mb-12">
            <h2 className="h2 mb-4">What is Staff Augmentation?</h2>
            <p style={{ fontSize: '18px', color: 'var(--text-medium)', maxWidth: '600px', margin: '0 auto' }}>
              Staff augmentation is a flexible engagement model where experienced engineers join your team as dedicated resources,
              giving you full control while we handle talent management and continuity.
            </p>
          </div>
          <div className="grid grid-3">
            <div className="card text-center">
              <FaRocket style={{ fontSize: '48px', color: 'var(--primary-green)', marginBottom: '16px' }} />
              <h3 className="h4 mb-4">Lightning-Fast Onboarding</h3>
              <p className="mb-4">Developers shortlisted and ready to start within 24-72 hours of requirement submission.</p>
              <ul style={{ textAlign: 'left', listStyle: 'none', padding: 0 }}>
                <li style={{ marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                  <FaCheckCircle style={{ color: 'var(--primary-green)', marginRight: '8px', fontSize: '16px' }} />
                  Pre-vetted technical interviews
                </li>
                <li style={{ marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                  <FaCheckCircle style={{ color: 'var(--primary-green)', marginRight: '8px', fontSize: '16px' }} />
                  Background verification complete
                </li>
                <li style={{ display: 'flex', alignItems: 'center' }}>
                  <FaCheckCircle style={{ color: 'var(--primary-green)', marginRight: '8px', fontSize: '16px' }} />
                  NDA and IP agreements ready
                </li>
              </ul>
            </div>
            <div className="card text-center">
              <FaLink style={{ fontSize: '48px', color: 'var(--primary-green)', marginBottom: '16px' }} />
              <h3 className="h4 mb-4">Seamless Integration</h3>
              <p className="mb-4">Our developers work as extensions of your existing team using your preferred tools and processes.</p>
              <ul style={{ textAlign: 'left', listStyle: 'none', padding: 0 }}>
                <li style={{ marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                  <FaCheckCircle style={{ color: 'var(--primary-green)', marginRight: '8px', fontSize: '16px' }} />
                  Jira, Slack, GitHub integration
                </li>
                <li style={{ marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                  <FaCheckCircle style={{ color: 'var(--primary-green)', marginRight: '8px', fontSize: '16px' }} />
                  Daily standups and code reviews
                </li>
                <li style={{ display: 'flex', alignItems: 'center' }}>
                  <FaCheckCircle style={{ color: 'var(--primary-green)', marginRight: '8px', fontSize: '16px' }} />
                  Sprint planning and retrospectives
                </li>
              </ul>
            </div>
            <div className="card text-center">
              <FaChartLine style={{ fontSize: '48px', color: 'var(--primary-green)', marginBottom: '16px' }} />
              <h3 className="h4 mb-4">Flexible Scaling</h3>
              <p className="mb-4">Scale your team size up or down based on project needs without long-term commitments.</p>
              <ul style={{ textAlign: 'left', listStyle: 'none', padding: 0 }}>
                <li style={{ marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                  <FaCheckCircle style={{ color: 'var(--primary-green)', marginRight: '8px', fontSize: '16px' }} />
                  Add resources instantly
                </li>
                <li style={{ marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                  <FaCheckCircle style={{ color: 'var(--primary-green)', marginRight: '8px', fontSize: '16px' }} />
                  Reduce team size as needed
                </li>
                <li style={{ display: 'flex', alignItems: 'center' }}>
                  <FaCheckCircle style={{ color: 'var(--primary-green)', marginRight: '8px', fontSize: '16px' }} />
                  No minimum contract periods
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Engineering Roles Section */}
      <section className="section">
        <div className="container">
          <div className="text-center mb-12">
            <h2 className="h2 mb-4">
              <span style={{ color: 'var(--text-dark)' }}>Our </span>
              <span style={{ color: 'var(--primary-green)' }}>Services</span>
            </h2>
            <p style={{ fontSize: '18px', color: 'var(--text-dark)', maxWidth: '800px', margin: '0 auto', lineHeight: '1.6' }}>
              The Code Icon offers comprehensive services encompassing website, app, software development, and digital marketing to enhance your online presence and business.
            </p>
          </div>
          <div className="services-grid" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '32px'
          }}>
            <div className="card" style={{ 
              padding: '32px', 
              position: 'relative',
              borderRadius: '12px',
              border: '1px solid var(--border-grey)',
              transition: 'all 0.3s ease'
            }}>
              <div style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                fontSize: '72px',
                fontWeight: '700',
                color: 'rgba(16, 185, 129, 0.15)',
                lineHeight: '1',
                fontFamily: 'monospace'
              }}>01</div>
              <FaCode style={{ fontSize: '48px', color: 'var(--primary-green)', marginBottom: '20px' }} />
              <h3 className="h4 mb-3" style={{ color: 'var(--text-dark)', fontWeight: '700' }}>Frontend Developers</h3>
              <p style={{ fontSize: '15px', lineHeight: '1.6', color: 'var(--text-medium)', marginBottom: '20px' }}>
                Professional frontend development service crafts custom, user-friendly interfaces with responsive design, seamless functionality, and tailored solutions for businesses and individuals.
              </p>
              <Link to="/services" style={{
                color: 'var(--primary-green)',
                textDecoration: 'underline',
                fontSize: '15px',
                fontWeight: '500',
                display: 'inline-block',
                marginTop: '8px'
              }}>View Details</Link>
            </div>
            <div className="card" style={{ 
              padding: '32px', 
              position: 'relative',
              borderRadius: '12px',
              border: '1px solid var(--border-grey)',
              transition: 'all 0.3s ease'
            }}>
              <div style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                fontSize: '72px',
                fontWeight: '700',
                color: 'rgba(16, 185, 129, 0.15)',
                lineHeight: '1',
                fontFamily: 'monospace'
              }}>02</div>
              <FaServer style={{ fontSize: '48px', color: 'var(--primary-green)', marginBottom: '20px' }} />
              <h3 className="h4 mb-3" style={{ color: 'var(--text-dark)', fontWeight: '700' }}>Backend Developers</h3>
              <p style={{ fontSize: '15px', lineHeight: '1.6', color: 'var(--text-medium)', marginBottom: '20px' }}>
                Backend development service creates robust, scalable server-side solutions, APIs, and database architectures, turning innovative ideas into powerful digital solutions for businesses and individuals.
              </p>
              <Link to="/services" style={{
                color: 'var(--primary-green)',
                textDecoration: 'underline',
                fontSize: '15px',
                fontWeight: '500',
                display: 'inline-block',
                marginTop: '8px'
              }}>View Details</Link>
            </div>
            <div className="card" style={{ 
              padding: '32px', 
              position: 'relative',
              borderRadius: '12px',
              border: '1px solid var(--border-grey)',
              transition: 'all 0.3s ease'
            }}>
              <div style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                fontSize: '72px',
                fontWeight: '700',
                color: 'rgba(16, 185, 129, 0.15)',
                lineHeight: '1',
                fontFamily: 'monospace'
              }}>03</div>
              <FaCode style={{ fontSize: '48px', color: 'var(--primary-green)', marginBottom: '20px' }} />
              <h3 className="h4 mb-3" style={{ color: 'var(--text-dark)', fontWeight: '700' }}>Full Stack Developers</h3>
              <p style={{ fontSize: '15px', lineHeight: '1.6', color: 'var(--text-medium)', marginBottom: '20px' }}>
                Full stack development service offers end-to-end expertise, reducing handoffs and accelerating delivery with comprehensive solutions from frontend to backend for businesses and individuals.
              </p>
              <Link to="/services" style={{
                color: 'var(--primary-green)',
                textDecoration: 'underline',
                fontSize: '15px',
                fontWeight: '500',
                display: 'inline-block',
                marginTop: '8px'
              }}>View Details</Link>
            </div>
            <div className="card" style={{ 
              padding: '32px', 
              position: 'relative',
              borderRadius: '12px',
              border: '1px solid var(--border-grey)',
              transition: 'all 0.3s ease'
            }}>
              <div style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                fontSize: '72px',
                fontWeight: '700',
                color: 'rgba(16, 185, 129, 0.15)',
                lineHeight: '1',
                fontFamily: 'monospace'
              }}>04</div>
              <FaMobile style={{ fontSize: '48px', color: 'var(--primary-green)', marginBottom: '20px' }} />
              <h3 className="h4 mb-3" style={{ color: 'var(--text-dark)', fontWeight: '700' }}>Mobile App Developers</h3>
              <p style={{ fontSize: '15px', lineHeight: '1.6', color: 'var(--text-medium)', marginBottom: '20px' }}>
                Mobile app development service creates customized mobile and web applications, turning innovative ideas into user-friendly digital solutions for businesses and individuals.
              </p>
              <Link to="/services" style={{
                color: 'var(--primary-green)',
                textDecoration: 'underline',
                fontSize: '15px',
                fontWeight: '500',
                display: 'inline-block',
                marginTop: '8px'
              }}>View Details</Link>
            </div>
            <div className="card" style={{ 
              padding: '32px', 
              position: 'relative',
              borderRadius: '12px',
              border: '1px solid var(--border-grey)',
              transition: 'all 0.3s ease'
            }}>
              <div style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                fontSize: '72px',
                fontWeight: '700',
                color: 'rgba(16, 185, 129, 0.15)',
                lineHeight: '1',
                fontFamily: 'monospace'
              }}>05</div>
              <FaBug style={{ fontSize: '48px', color: 'var(--primary-green)', marginBottom: '20px' }} />
              <h3 className="h4 mb-3" style={{ color: 'var(--text-dark)', fontWeight: '700' }}>QA & Automation Engineers</h3>
              <p style={{ fontSize: '15px', lineHeight: '1.6', color: 'var(--text-medium)', marginBottom: '20px' }}>
                QA and automation service offers comprehensive testing solutions, ensuring product quality through manual testing and automated pipelines for reliable, bug-free applications.
              </p>
              <Link to="/services" style={{
                color: 'var(--primary-green)',
                textDecoration: 'underline',
                fontSize: '15px',
                fontWeight: '500',
                display: 'inline-block',
                marginTop: '8px'
              }}>View Details</Link>
            </div>
            <div className="card" style={{ 
              padding: '32px', 
              position: 'relative',
              borderRadius: '12px',
              border: '1px solid var(--border-grey)',
              transition: 'all 0.3s ease'
            }}>
              <div style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                fontSize: '72px',
                fontWeight: '700',
                color: 'rgba(16, 185, 129, 0.15)',
                lineHeight: '1',
                fontFamily: 'monospace'
              }}>06</div>
              <FaCloud style={{ fontSize: '48px', color: 'var(--primary-green)', marginBottom: '20px' }} />
              <h3 className="h4 mb-3" style={{ color: 'var(--text-dark)', fontWeight: '700' }}>DevOps & Cloud Engineers</h3>
              <p style={{ fontSize: '15px', lineHeight: '1.6', color: 'var(--text-medium)', marginBottom: '20px' }}>
                DevOps and cloud service manages infrastructure, CI/CD pipelines, scaling, and monitoring, providing fast, reliable, and scalable solutions for modern businesses.
              </p>
              <Link to="/services" style={{
                color: 'var(--primary-green)',
                textDecoration: 'underline',
                fontSize: '15px',
                fontWeight: '500',
                display: 'inline-block',
                marginTop: '8px'
              }}>View Details</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Technology Section */}
      <section className="section" style={{ backgroundColor: 'white' }}>
        <div className="container">
          <div className="text-center mb-12">
            <h2 className="h2 mb-4" style={{ color: 'var(--primary-green)', fontSize: '48px', fontWeight: '700' }}>
              Technology
            </h2>
            <p style={{ fontSize: '18px', color: 'var(--text-dark)', maxWidth: '800px', margin: '0 auto', lineHeight: '1.6' }}>
              The Code Icon offering expert programming language solutions for businesses, ensuring seamless software development and innovation.
            </p>
          </div>

          {/* Technology Categories Navigation */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '32px',
            marginBottom: '48px',
            flexWrap: 'wrap',
            borderBottom: '2px solid var(--border-grey)',
            paddingBottom: '16px'
          }}>
            {technologyCategories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedTechCategory(category)}
                style={{
                  background: 'transparent',
                  border: 'none',
                  fontSize: '16px',
                  fontWeight: selectedTechCategory === category ? '700' : '500',
                  color: selectedTechCategory === category ? 'var(--primary-green)' : 'var(--text-dark)',
                  cursor: 'pointer',
                  padding: '8px 16px',
                  position: 'relative',
                  transition: 'all 0.3s ease'
                }}
              >
                {category}
                {selectedTechCategory === category && (
                  <div style={{
                    position: 'absolute',
                    bottom: '-18px',
                    left: '0',
                    right: '0',
                    height: '3px',
                    backgroundColor: 'var(--primary-green)',
                    borderRadius: '2px'
                  }}></div>
                )}
              </button>
            ))}
          </div>

          {/* Technology Icons Grid */}
          <div className="tech-grid" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(6, 1fr)',
            gap: '40px 20px',
            maxWidth: '1200px',
            margin: '0 auto'
          }}>
            {technologies[selectedTechCategory].map((tech, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  transition: 'transform 0.2s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.querySelector('.tech-icon').style.boxShadow = 'var(--shadow-md)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.querySelector('.tech-icon').style.boxShadow = 'none';
                }}
              >
                <div 
                  className="tech-icon"
                  style={{
                    width: '90px',
                    height: '90px',
                    borderRadius: '16px',
                    backgroundColor: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '16px',
                    border: '2px solid var(--border-grey)',
                    transition: 'all 0.3s ease',
                    boxShadow: 'var(--shadow-sm)'
                  }}
                >
                  <div style={{ fontSize: '48px', color: 'var(--text-dark)' }}>
                    {tech.icon}
                  </div>
                </div>
                <span style={{
                  fontSize: '14px',
                  fontWeight: '500',
                  color: 'var(--text-dark)',
                  marginTop: '4px'
                }}>
                  {tech.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="section" style={{ backgroundColor: 'var(--bg-grey-light)' }}>
        <div className="container">
          <div className="text-center mb-12">
            <h2 className="h2 mb-4">What Our Clients Say</h2>
            <p style={{ fontSize: '18px', color: 'var(--text-medium)' }}>
              Don't just take our word for it - hear from the companies we've helped scale
            </p>
          </div>
          <div className="grid grid-3">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="card" style={{ padding: '32px', position: 'relative' }}>
                <FaQuoteLeft style={{ fontSize: '32px', color: 'var(--primary-green)', opacity: 0.3, marginBottom: '16px' }} />
                <p style={{ fontSize: '16px', lineHeight: '1.6', marginBottom: '20px', fontStyle: 'italic' }}>
                  "{testimonial.content}"
                </p>
                <div style={{ display: 'flex', marginBottom: '12px' }}>
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <FaStar key={i} style={{ color: '#fbbf24', fontSize: '16px', marginRight: '4px' }} />
                  ))}
                </div>
                <div>
                  <div style={{ fontWeight: '600', fontSize: '16px' }}>{testimonial.name}</div>
                  <div style={{ color: 'var(--text-medium)', fontSize: '14px' }}>{testimonial.role}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Section */}
      <section className="section section-grey">
        <div className="container">
          <div className="text-center mb-12">
            <h2 className="h2 mb-4">Why Companies Choose The Code Icon</h2>
            <p style={{ fontSize: '18px', color: 'var(--text-medium)', maxWidth: '600px', margin: '0 auto' }}>
              Join industry leaders who trust us with their most critical engineering challenges
            </p>
          </div>
          <div className="grid grid-2" style={{ gap: '48px' }}>
            <div>
              <div style={{ marginBottom: '32px' }}>
                <h3 className="h3 mb-6" style={{ color: 'var(--primary-green)' }}>Quality Assurance</h3>
                <ul style={{ listStyle: 'none', padding: 0 }}>
                  <li style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '16px' }}>
                    <FaShieldAlt style={{ color: 'var(--primary-green)', marginRight: '12px', marginTop: '2px', fontSize: '18px' }} />
                    <div>
                      <strong>Pre-vetted Senior Engineers:</strong> Rigorous technical interviews and background checks
                    </div>
                  </li>
                  <li style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '16px' }}>
                    <FaShieldAlt style={{ color: 'var(--primary-green)', marginRight: '12px', marginTop: '2px', fontSize: '18px' }} />
                    <div>
                      <strong>Dedicated Replacement Guarantee:</strong> Fast replacement if expectations aren't met
                    </div>
                  </li>
                  <li style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '16px' }}>
                    <FaShieldAlt style={{ color: 'var(--primary-green)', marginRight: '12px', marginTop: '2px', fontSize: '18px' }} />
                    <div>
                      <strong>Weekly Reporting:</strong> Clear ownership and transparent progress tracking
                    </div>
                  </li>
                </ul>
              </div>
              <div>
                <h3 className="h3 mb-6" style={{ color: 'var(--primary-green)' }}>Security & Compliance</h3>
                <ul style={{ listStyle: 'none', padding: 0 }}>
                  <li style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '16px' }}>
                    <FaShieldAlt style={{ color: 'var(--primary-green)', marginRight: '12px', marginTop: '2px', fontSize: '18px' }} />
                    <div>
                      <strong>NDA & IP Protection:</strong> Enterprise-grade security and confidentiality agreements
                    </div>
                  </li>
                  <li style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '16px' }}>
                    <FaShieldAlt style={{ color: 'var(--primary-green)', marginRight: '12px', marginTop: '2px', fontSize: '18px' }} />
                    <div>
                      <strong>Timezone Alignment:</strong> US & EU business hours for smooth collaboration
                    </div>
                  </li>
                  <li style={{ display: 'flex', alignItems: 'flex-start' }}>
                    <FaShieldAlt style={{ color: 'var(--primary-green)', marginRight: '12px', marginTop: '2px', fontSize: '18px' }} />
                    <div>
                      <strong>Long-term Partnership:</strong> Flexible engagement models for sustained growth
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div>
              <div className="card" style={{ padding: '48px', textAlign: 'center', backgroundColor: 'white' }}>
                <FaHandshake style={{ fontSize: '48px', color: 'var(--primary-green)', marginBottom: '24px' }} />
                <h3 className="h3 mb-6">Build Your Team, Not Another Vendor Relationship</h3>
                <p className="mb-8" style={{ fontSize: '16px', lineHeight: '1.6' }}>
                  Scale faster, reduce hiring risk, and maintain full delivery control with The Code Icon's
                  staff augmentation services. We're not just vendors – we're your engineering partners.
                </p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  <Link to="/calculator" className="btn btn-primary btn-lg" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                    <FaRocket /> Get Team Cost Estimate
                  </Link>
                  <Link to="/how-it-works" className="btn btn-secondary" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                    <FaArrowRight /> Learn How It Works
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
